import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const BoxWrapper: CSSObject = {
  px: ['2', '3'],
};

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  boxShadow: 'none',
  border: '1px',
  borderColor: 'gray.200',
  borderRadius: 'md',
  mb: '2',

  _expanded: {
    boxShadow: 'none',
  },

  ...(isNested && {
    boxShadow: 'none',

    _last: { mb: 0 },
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  pb: '2',
  bg: 'white',
  borderBottomRadius: 'base',
  px: '2',
  ...(isNested && {
    bg: 'white',
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'white',
  color: 'epsilon.500',
  px: '2',
  py: '2.5',
  border: 'none',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'base',
  fontWeight: 'bold',
  fontSize: 'sm',

  _hover: {
    bg: 'epsilon.50',
  },

  '.chakra-accordion__icon': {
    boxSize: ['4', '5'],
    border: '2px',
    borderColor: 'beta.800',
    borderRadius: 'full',
    color: 'beta.800',
    transition: '.3s ease-in-out',
  },

  _expanded: {
    p: '2',
    borderBottomRadius: 'none',
  },

  ...(isNested && {
    bg: 'epsilon.400',
    color: 'white',
    borderBottomRadius: 0,
    px: '2',

    '.chakra-accordion__icon': {
      boxSize: ['4', '5'],
      border: '2px',
      borderColor: 'white',
      borderRadius: 'full',
      color: 'white',
      transition: '.3s ease-in-out',
    },

    _hover: {
      bg: 'epsilon.500',
    },
  }),
});
